import { LocaleContext, RegionContext } from 'Components/hooks/context';
import React, { useContext } from 'react';

import AtlasMetadataClient from '@reuters-graphics/graphics-atlas-client';
import Globe from './Globe';

import HeadlineNews from './HeadlineNews';
import classnames from 'classnames';
import { component } from './styles.module.scss';

const atlas = new AtlasMetadataClient();

const Headline = ({ globalStatistics, hasFetched }) => {
  const locale = useContext(LocaleContext);
  const region = useContext(RegionContext);
  return (
    <div className={classnames(component)}>
      <div className='section-spacer-internal' />
      <div className='clearfix'>
        <Globe location={region} />
        <div className='title-container'>
          <h1>{atlas.getRegion(region).translations[locale]}</h1>
          <HeadlineNews
            globalStatistics={globalStatistics}
            hasFetched={hasFetched}
          />
        </div>
      </div>
    </div>
  );
};

export default Headline;
